import { useEffect, useState, useContext } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import StationSelection from './StationSelection';
import AreaSelection from './AreaSelection';
import OptionsSelection from './OptionsSelection';
import { productParams } from './js/productParams';
import { StoredContext } from './App.js';

export default function UserInput(props) {
    const { product, userParams, setUserParams, setProcessRequest, ProductOptions } = props;
	const [ showStationSelection, setShowStationSelection ] = useState(true); 
	const [ showAreaSelection, setShowAreaSelection ] = useState(false); 
	const [ showOptionsSelection, setShowOptionsSelection ] = useState(true);
	const [ showGoButton, setShowGoButton] = useState(true);
	const [ disableGoButton, setDisableGoButton] = useState(false);
	const { storedParams, setStoredParams } = useContext(StoredContext);

	const clickedGo = () => {
		setShowOptionsSelection(false);
		setShowGoButton(false);
		if ((userParams.hasOwnProperty("sid") && userParams.sid !== "") ||
			(userParams.hasOwnProperty("area") && userParams.area !== "")) {
			setShowStationSelection(false);
			setShowAreaSelection(false);	
			setProcessRequest(true);
		} else if (userParams.hasOwnProperty("sid")) {
			alert("Need to select a station")
			setShowStationSelection(true);
		}
	}

	useEffect(() => {
		if (product.length > 0) {
			if (productParams(product).hasOwnProperty("sid")) {
				setUserParams({ ...productParams(product), sid: storedParams.sid, stnName: storedParams.stnName });	//combine with saved station info
				setShowStationSelection(true);
			} else if (productParams(product).hasOwnProperty("area")) {
				setUserParams({ ...productParams(product), area: storedParams.area, areaType: storedParams.areaType });	//combine with saved area info
				setShowAreaSelection(true);
			}
			setShowOptionsSelection(true);
			setShowGoButton(true);
		}
	}, [product])

	// Box below had flexGrow:1, but removed because believed unnecessary
    return (
		<>
			{ userParams &&
				<Box
					component="main"
					sx={{
						backgroundColor: (theme) => theme.palette.grey[100],
						overflow: 'auto',
						px: 2,
						pt: 8,
						pb: 1
					}}
				>
					{userParams.hasOwnProperty('sid') &&
						<StationSelection 
							userParams = {userParams}
							setUserParams = {setUserParams}
							showStationSelection = {showStationSelection}
							setShowStationSelection = {setShowStationSelection}
							setShowGoButton = {setShowGoButton}
						/>
					}
					{userParams.hasOwnProperty('area') &&
						<AreaSelection 
							userParams = {userParams}
							setUserParams = {setUserParams}
							showAreaSelection = {showAreaSelection}
							setShowAreaSelection = {setShowAreaSelection}
							setShowGoButton = {setShowGoButton}
						/>
					}
					<Divider sx={{ mt:1, mb: 1, borderColor: (theme) => theme.palette.grey[500] }} />
					<OptionsSelection 
						userParams = {userParams}
						setUserParams = {setUserParams}
						showOptionsSelection = {showOptionsSelection}
						setShowOptionsSelection = {setShowOptionsSelection}
						setDisableGoButton = {setDisableGoButton}
						ProductOptions = {ProductOptions}
					/>
					<Divider sx={{ mt:1, mb: 0, borderColor: (theme) => theme.palette.grey[500] }} />
					{(showGoButton || showOptionsSelection) &&
						<Button 
							sx={{ mt: 1 }}
							onClick={clickedGo} 
							disabled={disableGoButton}
						>
							Go
						</Button>
					}
				</Box>
			}
		</>	
    )
}
